import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PricingHero from './components/PricingHero';
import PricingTiers from './components/PricingTiers';
import PricingGuide from './components/PricingGuide';

export default function Pricing() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PricingHero />
      <PricingTiers />
      <PricingGuide />
      <Footer />
    </div>
  );
}